module.exports = __webpack_public_path__ + "img/empty.1766306608134.png";